import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { observer } from "mobx-react-lite"
import { useStore } from "../../../app/stores/store"

const HomeTrendType = () => {
    const { setSelectedType, typeOptions, selectedtype } = useStore().homeTrendChartStore
    
    const handleChange = (e: SelectChangeEvent) => {
        setSelectedType((Number(e.target.value)))
    }
    
    return (
        <FormControl fullWidth>
            <Select
                labelId="stationLabel"
                value={String(selectedtype) ?? 0}
                onChange={handleChange}
            >
                {typeOptions.map((item, index) => (
                    <MenuItem key={index} value={item.value}>{item.text}</MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default observer(HomeTrendType)